<template>
  <div class="filtros-servico-busca">
    <div class="cabecalho-filtros">
      <h5>Buscando por:</h5>
      <button
        v-if="temFiltrosAtivos"
        type="button"
        class="acao-limpar-filtros"
        @click="$emit('limpar')"
      >
        <i class="fa fa-times"></i>
        Limpar
      </button>
    </div>

    <div
      v-for="grupo in gruposFiltros"
      :key="grupo.id"
      class="grupo-filtro"
    >
      <button
        type="button"
        class="alternador-grupo-filtro"
        v-b-toggle="grupo.idColapso"
      >
        <span>
          {{ formatarTituloGrupo(grupo) }}
          <span
            v-if="contarSelecionados(grupo.id) > 0"
            class="quantidade-selecionada"
          >
            {{ contarSelecionados(grupo.id) }}
          </span>
        </span>
        <i class="fa fa-angle-down"></i>
      </button>

      <b-collapse :id="grupo.idColapso" role="tabpanel">
        <div class="opcoes-filtro">
          <div
            v-for="(item, indice) in grupo.itens"
            :key="obterIdItem(grupo.id, item, indice)"
            class="opcao-filtro"
          >
            <input
              type="checkbox"
              :id="obterIdItem(grupo.id, item, indice)"
              :checked="estaSelecionado(item.id, item.valor)"
              @change="$emit('alterar', item, $event.target.checked)"
            />
            <label
              :for="obterIdItem(grupo.id, item, indice)"
              :class="{ selecionado: estaSelecionado(item.id, item.valor) }"
            >
              {{ obterRotuloItem(item) }}
              <span class="quantidade-filtro">({{ item.quantidade || 0 }})</span>
            </label>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
export default {
  name: "filtrosServicoBusca",
  props: {
    temFiltrosAtivos: Boolean,
    filtros: {
      type: Array,
      default: () => [],
    },
    selecionados: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    gruposFiltros() {
      const ordem = {
        linha: 1,
        marca: 2,
        categoria: 3,
        subcategoria: 4,
      };
      const grupos = {};

      this.filtros.forEach((filtro) => {
        if (filtro.visivel === false) {
          return;
        }

        const id = this.normalizarTexto(filtro.id);
        const valor = this.normalizarTexto(filtro.valor);

        if (!id || !valor) {
          return;
        }

        if (!grupos[id]) {
          grupos[id] = {
            id,
            rotulo: filtro.labelTipo || id,
            idColapso: `filtro-servico-busca-${id}`,
            itens: [],
          };
        }

        grupos[id].itens.push(Object.assign({}, filtro, { id, valor }));
      });

      return Object.keys(grupos)
        .map((chave) => grupos[chave])
        .sort((grupoA, grupoB) => {
          const ordemA = ordem[grupoA.id] || 99;
          const ordemB = ordem[grupoB.id] || 99;

          return ordemA !== ordemB
            ? ordemA - ordemB
            : grupoA.rotulo.localeCompare(grupoB.rotulo);
        });
    },
  },
  methods: {
    normalizarTexto(valor) {
      return String(valor == null ? "" : valor).trim();
    },
    estaSelecionado(campo, valor) {
      const valores = this.selecionados[campo] || [];
      return valores.indexOf(this.normalizarTexto(valor)) > -1;
    },
    contarSelecionados(campo) {
      return (this.selecionados[campo] || []).length;
    },
    obterIdItem(grupoId, item, indice) {
      return `filtro-${grupoId}-${indice}-${this.criarSlug(item.valor)}`;
    },
    obterRotuloItem(item) {
      const valor = this.normalizarTexto(item.label || item.valor);
      const partes = valor.split(" > ");
      return partes[partes.length - 1] || valor;
    },
    formatarTituloGrupo(grupo) {
      const titulos = {
        linha: "LINHA DE PRODUTOS",
        marca: "MARCA",
        categoria: "CATEGORIA",
        subcategoria: "SUB CATEGORIA",
      };
      const id = this.normalizarTexto(grupo.id).toLowerCase();

      return titulos[id] || this.normalizarTexto(grupo.rotulo).toUpperCase();
    },
    criarSlug(valor) {
      return this.normalizarTexto(valor)
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
    },
  },
};
</script>

<style scoped>
.filtros-servico-busca {
  margin-top: -106px;
  position: relative;
  z-index: 4;
}

.cabecalho-filtros {
  align-items: flex-start;
  display: flex;
  height: 35px;
  justify-content: space-between;
}

.cabecalho-filtros h5 {
  color: #151b24;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.2;
  margin: 0;
}

.acao-limpar-filtros {
  align-items: center;
  background: transparent;
  border: 0;
  color: #0d6efd;
  cursor: pointer;
  display: inline-flex;
  font-size: 13px;
  gap: 0.35rem;
  line-height: 1;
  margin-top: 0;
  padding: 0;
}

.acao-limpar-filtros:hover {
  color: #0056b3;
  text-decoration: underline;
}

.grupo-filtro {
  background: #f7f7f8;
  border: 1px solid #e2e5e9;
  border-radius: 7px;
  margin-bottom: 8px;
  overflow: hidden;
}

.alternador-grupo-filtro {
  align-items: center;
  background: #f7f7f8;
  border: 0;
  color: #14345d;
  cursor: pointer;
  display: flex;
  font-size: 12px;
  font-weight: 700;
  justify-content: space-between;
  min-height: 42px;
  padding: 0.7rem 0.85rem;
  text-align: left;
  width: 100%;
}

.alternador-grupo-filtro:focus,
.alternador-grupo-filtro:active {
  border: 0;
  box-shadow: none;
  outline: 0;
}

.alternador-grupo-filtro > span {
  align-items: center;
  display: flex;
  min-width: 0;
}

.alternador-grupo-filtro .fa-angle-down {
  color: #14345d;
  flex: 0 0 auto;
  font-size: 15px;
  transition: transform 0.2s ease;
}

.alternador-grupo-filtro:not(.collapsed) .fa-angle-down {
  transform: rotate(180deg);
}

.quantidade-selecionada {
  align-items: center;
  background: #14345d;
  border-radius: 50%;
  color: #fff;
  display: inline-flex;
  flex: 0 0 18px;
  font-size: 10px;
  height: 18px;
  justify-content: center;
  line-height: 1;
  margin-left: 0.35rem;
  min-width: 18px;
  padding: 0 4px;
}

.opcoes-filtro {
  padding: 0.2rem 0.85rem 0.75rem;
}

.opcao-filtro {
  align-items: center;
  display: flex;
  gap: 0.4rem;
  min-height: 24px;
}

.opcao-filtro input {
  accent-color: #1687e8;
  cursor: pointer;
  flex: 0 0 15px;
  height: 15px;
  margin: 0;
  width: 15px;
}

.opcao-filtro label {
  color: #4b5563;
  cursor: pointer;
  font-size: 12px;
  line-height: 1.35;
  margin: 0;
  overflow-wrap: anywhere;
}

.opcao-filtro label.selecionado {
  color: #14345d;
  font-weight: 700;
}

.quantidade-filtro {
  color: #8a94a3;
  font-weight: 400;
}

@media (max-width: 767px) {
  .filtros-servico-busca {
    margin-top: 0;
  }
}
</style>
